import * as React from 'react';
import { connect } from 'react-redux';
import { createRouteNodeSelector } from 'redux-router5';
import { navigate } from '~/router';
import SideMenu from '~/common/menu/SideMenu';
import { UserRole } from '~/apps/shared/consts';


function SideMenuContainer(props) {
  const { route, auth: { currentUser: { role } } } = props;
  const isLocationSelect = role !== UserRole.WAREHOUSE_MANAGER;

  let items = [
    {
      iconClass: 'i-help',
      text: 'Help',
      isActive: route.name.startsWith('pos.mobile.help'),
      onClick: (e) => navigate('pos.mobile.help'),
    },
    {
      iconClass: 'i-delay',
      text: 'Logout',
      isActive: route.name.startsWith('logout'),
      onClick: (e) => navigate('logout'),
    },
  ];

  return (
    <SideMenu items={items} bottom />
  );
}


const mapStateToProps = (state) => {
  const routeNodeSelector = createRouteNodeSelector('pos.mobile');

  return {
    auth: state.shared.auth,
    ...routeNodeSelector(state),
  }
};

export default connect(mapStateToProps)(SideMenuContainer);
